import React from 'react';

export const getSkyDividerColor = () => '#0a1628';

const SkyHeader = ({ children }) => {
  return (
    <div className="relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0a0a1a 0%, #0d1b2a 40%, #1b2838 100%)' }}>
      {/* Stars - dense field */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(40)].map((_, i) => {
          const size = i % 5 === 0 ? 3 : i % 3 === 0 ? 2 : 1;
          const isGlow = i % 7 === 0;
          return (
            <div
              key={i}
              className="absolute rounded-full"
              style={{
                width: `${size}px`,
                height: `${size}px`,
                left: `${(i * 23 + 7) % 98}%`,
                top: `${(i * 17 + 3) % 65}%`,
                opacity: 0.1 + (i % 5) * 0.12,
                background: isGlow ? 'radial-gradient(circle, rgba(212,175,55,0.9), rgba(212,175,55,0.3), transparent)' : 'white',
                boxShadow: isGlow ? '0 0 4px 1px rgba(212,175,55,0.4)' : size > 1 ? '0 0 2px rgba(255,255,255,0.3)' : 'none',
                animation: `twinkle ${2 + (i % 4) * 1.2}s ease-in-out infinite ${i * 0.3}s`
              }}
            />
          );
        })}
      </div>

      {/* Shooting stars */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute" style={{
          width: '80px', height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)',
          top: '15%', left: '-10%',
          animation: 'shootingStar 6s linear infinite 1s',
          transform: 'rotate(-25deg)'
        }} />
        <div className="absolute" style={{
          width: '60px', height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.7), transparent)',
          top: '35%', left: '-10%',
          animation: 'shootingStar 8s linear infinite 4s',
          transform: 'rotate(-20deg)'
        }} />
        <div className="absolute" style={{
          width: '50px', height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(200,220,255,0.6), transparent)',
          top: '8%', left: '-10%',
          animation: 'shootingStar 7s linear infinite 7s',
          transform: 'rotate(-30deg)'
        }} />
      </div>

      {/* Pulsing nebula glow spots */}
      <div className="absolute pointer-events-none" style={{
        width: '120px', height: '120px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(212,175,55,0.08), transparent 70%)',
        top: '5%', left: '20%',
        animation: 'nebulaPulse 5s ease-in-out infinite'
      }} />
      <div className="absolute pointer-events-none" style={{
        width: '80px', height: '80px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(100,180,255,0.06), transparent 70%)',
        top: '10%', right: '15%',
        animation: 'nebulaPulse 7s ease-in-out infinite 2s'
      }} />

      {/* Aurora */}
      <div className="absolute inset-0 pointer-events-none" style={{ opacity: 0.35 }}>
        <div className="absolute w-[200%] h-full" style={{
          background: 'linear-gradient(90deg, transparent 0%, rgba(0,255,128,0.15) 15%, rgba(0,200,255,0.2) 30%, rgba(100,0,255,0.1) 45%, transparent 60%, rgba(0,255,180,0.15) 75%, rgba(0,150,255,0.18) 90%, transparent 100%)',
          animation: 'auroraFlow 20s ease-in-out infinite',
          filter: 'blur(20px)'
        }} />
      </div>

      {/* Mountains */}
      <div className="absolute bottom-0 left-0 right-0 pointer-events-none">
        <svg viewBox="0 0 400 60" preserveAspectRatio="none" className="w-full h-8" style={{ opacity: 0.3 }}>
          <path d="M0,60 L0,35 Q30,10 60,30 Q80,15 100,25 Q130,5 160,28 Q190,12 220,22 Q250,8 280,30 Q310,15 340,25 Q370,10 400,32 L400,60 Z" fill="#0d1b2a"/>
        </svg>
        <svg viewBox="0 0 400 45" preserveAspectRatio="none" className="w-full h-6 -mt-4" style={{ opacity: 0.5 }}>
          <path d="M0,45 L0,30 Q40,12 80,25 Q110,8 140,22 Q170,15 200,20 Q230,5 260,25 Q290,12 320,20 Q350,8 380,28 L400,22 L400,45 Z" fill="#111d2e"/>
        </svg>
        <svg viewBox="0 0 400 35" preserveAspectRatio="none" className="w-full h-4 -mt-3" style={{ opacity: 0.7 }}>
          <path d="M0,35 L0,25 Q50,15 100,22 Q140,10 180,20 Q210,14 240,18 Q270,8 300,22 Q340,15 380,20 L400,18 L400,35 Z" fill="#162030"/>
        </svg>
      </div>

      <div className="relative z-10">{children}</div>

      <style>{`
        @keyframes twinkle { 0%, 100% { opacity: 0.08; transform: scale(0.8); } 50% { opacity: 0.9; transform: scale(1.2); } }
        @keyframes auroraFlow { 0% { transform: translateX(0%); } 50% { transform: translateX(-25%); } 100% { transform: translateX(0%); } }
        @keyframes shootingStar { 0% { left: -10%; opacity: 0; } 5% { opacity: 1; } 30% { left: 110%; opacity: 0; } 100% { left: 110%; opacity: 0; } }
        @keyframes nebulaPulse { 0%, 100% { opacity: 0.3; transform: scale(1); } 50% { opacity: 0.8; transform: scale(1.3); } }
      `}</style>
    </div>
  );
};

export default SkyHeader;
